import constants from '../constants';
import { elHasClass } from '../utils';

export default (dc, config = {}) => {
    const defaultType = dc.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;
    const { slideName, wrapperSelector } = constants;

    dc.addType(slideName, {
        model: defaultModel.extend(
            {
                init() {
                    const defaultProps = {
                        name: 'Slide',
                        badgable: false,
                        draggable: wrapperSelector,
                        droppable: true,
                        selectable: false,
                    };

                    const mergedProps = {
                        ...defaultProps,
                        ...config.slideProps,
                    };

                    if (config.slideProps?.style) {
                        mergedProps.style = {
                            ...(defaultProps.style || {}),
                            ...config.slideProps.style,
                        };
                    } else if (defaultProps.style) {
                        mergedProps.style = defaultProps.style;
                    }

                    this.set(mergedProps);
                },
            },
            {
                isComponent(el) {
                    if (elHasClass(el, config.classSlide)) {
                        return { type: slideName };
                    }
                },
            }
        ),

        view: defaultView,
    });
};
